import {CustomTextarea} from "@/pages/assistants/ScenarioStepsPage/components/CustomTextarea.tsx";
import {TextareaHTMLAttributes, useState, useCallback, useRef} from "react";
import {TTableDataItem} from "@/pages/assistants/ScenarioStepsPage";
import { Toast } from "@/components/ui/Toast";

interface TEditStepNumber extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    value: string;
    setValue: (value: number) => void;
    tableData: Array<TTableDataItem>
}

export const EditStepNumber = ({ value, setValue, tableData }: TEditStepNumber) => {
    const [localValue, setLocalValue] = useState(value);
    const [showError, setShowError] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout>();

    const debouncedValidation = useCallback((val: number) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            const exists = tableData.some(item => item.step === val);
            if (exists) {
                setShowError(true);
            } else {
                setValue(val);
                setShowError(false);
            }
        }, 500);
    }, [tableData, setValue]);

    const handleClose = () => {
        setShowError(false)
        setLocalValue(value)
    }

    const handleSetValue = (val: string) => {
        setLocalValue(val);
        debouncedValidation(Number(val));
    }

    return (
        <div>
            <CustomTextarea value={localValue} setValue={handleSetValue} />
            {showError && (
                <Toast
                    message="Шаг с таким номером уже существует. Изменения не будут сохранены."
                    type="error"
                    onClose={handleClose}
                    duration={3000}
                />
            )}
        </div>
    )
}
